<template>
  <div v-if="loading" class="spinner-container">
    <div class="spinner"></div>
  </div>
  <div v-else>
    <div class="homepage d-flex flex-column vh-100">
      <!-- Navbar -->
      <div class="homepage-navbar bg-light shadow  p-3 bg-primary ">
        <div class="d-flex align-items-center">
          <span @click="goBack()" class="text-white">
            <i class="bi bi-arrow-left fs-5"></i>
          </span>
          &nbsp; &nbsp;
          <span>
            <h4 class="text-white">{{ language?.booking_details }}</h4>
          </span>
          <div class="d-flex align-items-center gap-2 ms-auto"></div>
        </div>
      </div>

      <!-- Body -->
      <div class="mt-2 my-auto overflow-auto pb-5">
        <div class="container pt-0" ref="captureArea">
          <!-- Laundry Details -->
          <div class="text-center">
            <div class="row">
              <div class="col-4">
            <!--<img  v-if="!imagePreview" :src="loadBase64Image" alt="Order Image" height="100px">-->
            <img  v-if="!imagePreview && base64Image" :src="base64Image" alt="Order Image" height="100px">

            </div>
            <div class="col-8">
            <h3 class="p-0 m-0">{{ laundry_details?.name }}</h3>
            <p class="p-0 m-0">{{ laundry_details?.address }}</p>
            <p class="p-0 m-0"><i class="bi bi-phone"></i> {{ laundry_details?.contact }}</p>
            </div>
            </div>
           
          </div>
          <hr />

 
      

    <div>
         <span><strong>Room Details</strong></span> <br>
<table class="table">
<tr>
  <td>
     Room No
  </td>
  <td>
   {{ get_room_booking_info?.room_no }}
  </td>
  
    </tr><tr>
   <td>
     Entry Date 
  </td>
  <td>
   {{ get_room_booking_info?.iddate }}
  </td>
  </tr><tr>

   <td>
     Check In
  </td>
  <td>
   {{ get_room_booking_info?.fromdate }}
  </td>
  </tr><tr>

    <td>
     Check Out
  </td>
<td>
  {{ (get_room_booking_info.checkoutdate && get_room_booking_info.checkoutdate !== '0000-00-00 00:00:00') 
      ? get_room_booking_info.checkoutdate 
      : 'Not Check-Out' }}
</td>


</tr>
</table>
 
 

              </div>

               <hr>
              <div>

                 <span><strong>Customer Details</strong></span> <br>
                  <hr>


                        <div class="col-12">
                        <div class="row fw-bold" v-for="(item, index) in get_cust_info" :key="index">
                          <span>
                            {{index+1}}) {{ item.cust_name }}
                            <span style="margin-left: 30px;">
                               <a :href="'tel:' + item.cust_contact">{{ item.cust_contact }}</a>
                            </span>
                            <span style="margin-left: 30px;" v-if="item.cust_gender">
                              / {{ item.cust_gender }}
                            </span>
                          </span>
                        </div>
                      </div>

                </div>

                <hr>
                <div v-if="get_service_list.length>0">
                  <hr>
                  <span><strong>Add-On Charges</strong></span><br>

                           <table class="table table-striped">
                      <thead>
                        <tr>
                          <th>#</th>
                          <th>Add-On</th>
                          <th>Total</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr v-for="(item, index) in get_service_list" :key="index">
                          <td>{{ index + 1 }}</td>
                          <td>{{ item.servicename }}</td>
                          <td>{{ item.total }}</td>
                        </tr>
                      </tbody>
                       <tfoot>
                            <tr>
                              <td colspan="2" class="text-end"><strong>Total</strong></td>
                              <td><strong>{{ totalPaid }}</strong></td>
                            </tr>
                          </tfoot>
                    </table>

                  </div>






  <hr>


         <div>
          
  <hr>
  
         <div class="col-12 row">
          <div class="col-6">
            <span><strong>Total :{{  get_total.total_amt }}</strong></span>
            </div>
             <div class="col-6">
              <span><strong>Paid :{{ get_paid.paid_amt }}</strong></span>
            </div>
          </div>
          </div>
            <hr>

















         <text v-if="laundry_details.footermessage"><strong>Terms And Condition.</strong></text>
          <p class="mt-1">{{laundry_details.footermessage}}</p>
          <p class="text-center">Thank You, Visit Again...</p>
        </div>
      
        
        <!-- Capture & Share Button -->
        <div class="text-center mt-3">
          <button class="btn btn-primary" @click="captureView">
            <i class="bi bi-share"></i> Capture & Share
          </button>
          <button @click="shareOnWhatsApp" class="btn btn-success" v-if="order?.pdf_file" style="margin-left: 2px;"><i class="bi bi-whatsapp"></i> Share PDF On WhatsApp</button>
        </div>
      </div>
    </div>
  </div>
</template>

<style>
.bottom_border{
        border-bottom: 1px solid gray;
}
.footer_area{
        position: fixed;
        width: -webkit-fill-available;
        bottom: 0;
        background: aliceblue;
        padding: 5px 10px;
}
    .custom_height {
           min-height: 80vh;
        max-height: 80vh;
        overflow-y: auto;
    }
</style>
<script>
import axios from "@/plugins/axios"; 
import html2canvas from "html2canvas";
 
  export default {
    name: 'OrderDetails',
    components: {
    },
    

    mounted() {
      //  this.fetchWeather();
      if(this.$route.query.id)
            this.getOrderDetails(this.$route.query.id); // Call the method here

    }, 
  computed: {
  totalPaid() {
    return this.get_service_list.reduce((sum, item) => {
      return sum + Number(item.total || 0);
    }, 0);
  }
},
    data() {
      return { 
        loading: false,
        error: null,
        orderlist:[],
        order:[],
        customer:[],
        laundry_details:[],

        get_room_booking_info:[],
        get_service_list:[],
        get_total:[],
        get_due:[],
        get_paid:[],






        language:this.getLocalStorageArray('lang'),
        base64Image: null,
        pdfBlobUrl: "", 
        assetpath:'',
        pdf_file:''
      }
    },
    methods: {
      initializeHomeContent() {


      },

  async generatePDF() {
        
    },
     
            shareOnWhatsApp() {
            //   if (!this.pdfBlobUrl) {
            //     console.error("No PDF available to share.");
            //     return;
            //   }
            if(this.customer?.contact){
                  let phoneNumber = this.customer?.contact || "91XXXXXXXXXX"; // Customer's contact number
                  if(phoneNumber.length==10)
                        phoneNumber="91"+phoneNumber;
                        
                  const message = `Hello, here is your laundry bill. Please download it from: ${this.assetpath+""+this.order.pdf_file}`;
                  const whatsappUrl = `https://wa.me/${phoneNumber}?text=${encodeURIComponent(message)}`;
                
                  // Open WhatsApp
                //   window.open(whatsappUrl, "_blank");
                window.location.href = whatsappUrl;
                }
            }, 
      goBack() {
          
          this.$router.go(-1);
  },
        
        
         async convertImageToBase64(url) {
                    try {
                      const response = await fetch(url);
                      const blob = await response.blob();
                      return new Promise((resolve) => {
                        const reader = new FileReader();
                        reader.onloadend = () => resolve(reader.result);
                        reader.readAsDataURL(blob);
                      });
                    } catch (error) {
                      console.error("Error converting image to Base64:", error);
                      return null;
                    }
                  },
                
                  async loadBase64Image() {
                    const imageUrl = this.$asset_path + "addlaundry/" + this.laundry_details.img;
                    // alert(imageUrl);
                    this.base64Image = await this.convertImageToBase64(imageUrl);
                  },
                  
                  
                  
                  
       async captureView() {
  const element = this.$refs.captureArea;

  // Wait for all images to load before capturing
  const images = element.getElementsByTagName("img");
  await Promise.all(
    Array.from(images).map((img) => {
      return new Promise((resolve, reject) => {
        if (img.complete) resolve(); // Image is already loaded
        img.onload = resolve;
        img.onerror = reject;
      });
    })
  );

  // Capture with html2canvas
  html2canvas(element, {
    useCORS: true, // Allow cross-origin images
    logging: true,
    scale: 2, // Improve image quality
  }).then((canvas) => {
    canvas.toBlob((blob) => {
      if (!blob) return;

      const file = new File([blob], "bill_print.png", { type: "image/png" });

      // Web Share API support check
      if (navigator.canShare && navigator.canShare({ files: [file] })) {
        navigator
          .share({
            title: "Order No: #" + this.order.id, // Fix self.order to this.order
            text: this.share_msg,
            files: [file],
          })
          .catch((err) => console.error("Sharing failed", err));
      } else {
        // Fallback: Download image
        const link = document.createElement("a");
        link.href = URL.createObjectURL(blob);
        link.download = "bill_print.png";
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      }
    }, "image/png");
  });
},

      
        
      async getOrderDetails(id) {
        this.loading = true;
        this.error = null;

        try {
          var self = this;
          axios.post("get_invoice",{id:id}).then((response) => {
            
            self.assetpath = response.data.assetpath;
            self.laundry_details = response.data.laundry_details;


            self.get_room_booking_info = response.data.get_room_booking_info;
            self.get_cust_info = response.data.get_cust_info;
            self.get_paid = response.data.get_paid;
            self.get_service_list = response.data.get_service_list;
            self.get_total = response.data.get_total;
            self.get_due = response.data.get_due;
            self.language = response.data.language;
            localStorage.setItem('lang', response.data.language);
           
            
                     self.language=response.data.language;
                     localStorage.setItem('lang',response.data.language);

          }).then(() => { 
               self.loadBase64Image(); 
          }).catch((err) => {

          });;


        } catch (err) {
          this.error = err.response?.data?.message || "Login failed. Please try again.";
        } finally {
          this.loading = false;
        }
      },


      async updatestatus(status="") {
        this.loading = true;
        this.error = null;

        try {
          var self = this;
          axios.post("updatestatus",{orderid:self.order.id,status:status}).then((response) => {
            
            self.orderlist = response.data.orderlist;
            self.order = response.data.order;
            self.laundry_details = response.data.laundry_details;
            self.$swal.fire(response.data.message);
            
                     self.language=response.data.language;
                     localStorage.setItem('lang',response.data.language);

          }).then(() => { 
          }).catch((err) => {

          });;


        } catch (err) {
          this.error = err.response?.data?.message || "Login failed. Please try again.";
        } finally {
          this.loading = false;
        }
      },




      
      getLocalStorageArray(key) {
        let data = localStorage?.getItem(key);
        try {
            return data ? JSON.parse(data) : [];
        } catch (e) {
            console.error("Error parsing localStorage data", e);
            return [];
        }
    }

    }
  }






</script>